document.addEventListener("DOMContentLoaded", function () {
    const bulkOptions = document.querySelectorAll(".bulks a");
    const priceBox = document.querySelector(".price-item--regular"); // Main price
    const unitPriceBox = document.querySelector(".unit-price .price-item"); // Unit price
    const quantityInput = document.querySelector(".main-pdp-quantity"); // Quantity input

    bulkOptions.forEach((option) => {
        option.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent default link behavior

            // Check if the clicked option has the "soldout" class
            if (this.classList.contains("soldout")) {
                return; // Do nothing if sold out
            }

            // Remove active class from all .planeo-variant elements
            bulkOptions.forEach((el) => {
                const variant = el.querySelector(".planeo-variant");
                if (variant) variant.classList.remove("active");

                el.style.pointerEvents = "auto"; // Enable click on other options
            });

            // Add active class to the clicked one's .planeo-variant
            const selectedVariant = this.querySelector(".planeo-variant");
            if (selectedVariant) selectedVariant.classList.add("active");

            // Disable pointer events on the selected option
            this.style.pointerEvents = "none";

            // Get values from data attributes
            const newPrice = this.getAttribute("data-price");
            const newUnitPrice = this.getAttribute("data-unit-price");
            const newQuantity = this.getAttribute("data-quantity");

            // Update the price in the buy box
            if (priceBox) {
                priceBox.textContent = (parseInt(newPrice) / 100).toLocaleString("de-DE", { minimumFractionDigits: 2 }) + " €";
            }

            // Update unit price in the buy box
            if (unitPriceBox) {
                unitPriceBox.textContent = newUnitPrice;
            }

            // Update the quantity input field
            if (quantityInput) {
                quantityInput.value = newQuantity;
            }
        });
    });
});